import React from 'react';
import Avatar from '../Avatar';
import FollowButton from './FollowButton';
import { useAuth } from '../../contexts/AuthContext';
import { getBadgeByKey } from '../../lib/badgeDefinitions';

/**
 * Card di un profilo pubblico nella lista Community.
 * user: { id, name, username, avatar_url, selected_badge, current_level, is_following }
 */
function UserCard({ user, onClick }) {
  const { profile } = useAuth();
  const title = user.selected_badge ? getBadgeByKey(user.selected_badge) : null;
  const isSelf = profile?.id === user.id;

  return (
    <div className="w-full flex items-center gap-3 bg-white rounded-2xl p-3 shadow-sm">
      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-3 min-w-0 flex-1 text-left"
      >
        <Avatar name={user.name} seed={user.id} src={user.avatar_url} size="w-12 h-12" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-gray-900 truncate">{user.name || 'Atleta'}</p>
          <p className="text-xs text-gray-400 truncate">
            {user.username ? `@${user.username}` : ''} · Liv. {user.current_level || 1}
          </p>
          {title && (
            <p className="text-xs text-primary-600 font-semibold flex items-center gap-1 mt-0.5 truncate">
              <span>{title.icon}</span>
              <span className="truncate">{title.name}</span>
            </p>
          )}
        </div>
      </button>

      {isSelf ? (
        <span className="shrink-0 text-xs text-gray-400 font-medium px-2">Tu</span>
      ) : (
        <FollowButton targetId={user.id} following={user.is_following} />
      )}
    </div>
  );
}

export default UserCard;
